import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	type DialogProps,
	Grid,
	makeStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { ErrorModal } from "@dexteel/mesf-core";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { DialogHeader } from "./dialogs-header/dialog-header";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiInputBase-input": {
			color: "#000",
		},
		"& .MuiPaper-root": {
			height: "auto",
		},
	},
	reponsive: {
		[theme.breakpoints.up("md")]: {
			padding: "8px 8px 4px !important",
		},
	},
}));

const VITE_DOCUMENT_PATH =
	import.meta.env.VITE_DOCUMENT_PATH ||
	"https://mill-cmms.roanokesteel.com/vaultix/";

type Props = {
	show?: boolean;
	onHide?: (onHide: boolean) => void;
};

export const DrawingViewer = ({ show = true, onHide = () => {} }: Props) => {
	const classes = useStyles();
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState<DialogProps["maxWidth"]>("lg");
	const [getVersionError, setGetVersionError] = useState<string>("");
	const [getPartsError, setGetPartsError] = useState<string>("");

	const {
		state: { rowSelectedInDrawing },
		actions: { setDocumentIdRowSelected },
	} = useWorkOrderModalsContext();

	const handleCancel = () => {
		onHide(false);
	};

	const DownloadOriginal = () => {
		const link = document.createElement("a");
		link.href = `${VITE_DOCUMENT_PATH}${rowSelectedInDrawing?.DocPath}`;
		link.setAttribute("target", "_blank}");
		link.setAttribute(
			"download",
			`${rowSelectedInDrawing?.Title} ${rowSelectedInDrawing?.DocPath}`,
		);
		document.body.appendChild(link);
		link.click();
	};

	const DownloadPDF = () => {
		const link = document.createElement("a");
		link.href = `${VITE_DOCUMENT_PATH}${rowSelectedInDrawing?.PDFPath}`;
		link.setAttribute("target", "_blank");
		link.setAttribute(
			"download",
			`${rowSelectedInDrawing?.Title} ${rowSelectedInDrawing?.PDFPath}.pdf`,
		);
		document.body.appendChild(link);
		link.click();
	};

	const DownloadPNG = () => {
		const link = document.createElement("a");
		link.href = `${VITE_DOCUMENT_PATH}${rowSelectedInDrawing?.PNGPath}`;
		link.setAttribute("target", "_blank");
		link.setAttribute(
			"download",
			`${rowSelectedInDrawing?.Title} ${rowSelectedInDrawing?.PNGPath}.png`,
		);
		document.body.appendChild(link);
		link.click();
	};

	useEffect(() => {
		if (show && rowSelectedInDrawing) {
			setDocumentIdRowSelected(rowSelectedInDrawing.DocumentId);
		}
	}, [show, rowSelectedInDrawing]);

	return (
		<>
			<Dialog
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				open={show}
				onClose={() => handleCancel()}
				className={classes.root}
			>
				<Grid container style={{ padding: "15px 0 0" }}>
					<DialogHeader />
				</Grid>
				<DialogContent dividers>
					<Grid container>
						<Grid
							container
							item
							md={12}
							xs={12}
							style={{
								justifyContent: "center",
								alignItems: "center",
								marginBottom: 10,
								padding: "10px 0",
								overflow: "hidden",
							}}
						>
							<object
								data={`${VITE_DOCUMENT_PATH}${rowSelectedInDrawing?.TMBPath}`}
								type="image/png"
								style={{
									objectFit: "cover",
									minHeight: 310,
									maxHeight: 310,
									display: "flex",
									alignItems: "center",
								}}
							>
								<img
									style={{
										objectFit: "cover",
										objectPosition: "center",
										verticalAlign: "middle",
									}}
									src="img/notFound.jpg"
									alt={`Drawing: ${rowSelectedInDrawing?.Title}`}
									loading="lazy"
								/>
							</object>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions style={{ padding: "8px 0" }}>
					<Grid
						container
						justifyContent="space-between"
						style={{ margin: "0 26px" }}
					>
						<Grid container item md={6} xs={12} justifyContent="flex-start">
							<Grid
								item
								md={4}
								xs={12}
								style={{ margin: 0, padding: "8px 10px" }}
							>
								<Button
									fullWidth
									variant="contained"
									color="default"
									onClick={handleCancel}
								>
									Close
								</Button>
							</Grid>
							<Grid
								item
								md={5}
								xs={12}
								style={{ margin: 0, padding: "8px 10px" }}
							></Grid>
							<Grid
								item
								md={3}
								xs={12}
								style={{ margin: 0, padding: "8px 10px" }}
							></Grid>
						</Grid>
						<Grid container item md={6} xs={12}>
							<Grid
								item
								md={4}
								xs={4}
								style={{ margin: 0, padding: "8px 10px" }}
							>
								<Button
									disabled={
										rowSelectedInDrawing?.DocPath == null ||
										rowSelectedInDrawing?.DocPath === ""
									}
									fullWidth
									variant="outlined"
									color="primary"
									onClick={DownloadOriginal}
									style={
										!rowSelectedInDrawing?.PNGPath
											? { border: "1px solid #BDBDBD" }
											: {}
									}
								>
									Original
								</Button>
							</Grid>
							<Grid
								item
								md={4}
								xs={4}
								style={{ margin: 0, padding: "8px 10px" }}
							>
								<Button
									disabled={
										rowSelectedInDrawing?.PNGPath == null ||
										rowSelectedInDrawing?.PNGPath === ""
									}
									fullWidth
									variant="outlined"
									style={
										rowSelectedInDrawing?.PNGPath
											? {
													border: "1px solid #357a38",
													color: "#357a38",
												}
											: { border: "1px solid #BDBDBD" }
									}
									onClick={DownloadPNG}
								>
									IMAGE
								</Button>
							</Grid>
							<Grid
								item
								md={4}
								xs={4}
								style={{ margin: 0, padding: "8px 10px" }}
							>
								<Button
									disabled={
										rowSelectedInDrawing?.PDFPath == null ||
										rowSelectedInDrawing?.PDFPath === ""
									}
									fullWidth
									variant="outlined"
									color="secondary"
									onClick={DownloadPDF}
								>
									PDF
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</DialogActions>
				<ErrorModal
					error={getVersionError}
					onHide={() => setGetVersionError("")}
				/>
				<ErrorModal error={getPartsError} onHide={() => setGetPartsError("")} />
			</Dialog>
		</>
	);
};
